<template>
  <div class="container-fluid">
    <apexchart
      :key="chartKey"
      height="350"
      :options="chartOptions"
      :series="chartOptions.series"
    ></apexchart>
  </div>
</template>

<script>
export default {
  name: 'AllocatedProfitsChart',
  data() {
    return {
      chartKey: 0,
      chartOptions: {
        chart: {
          type: 'bar',
          horizontal: true,
          toolbar: { show: false },
          fontFamily: 'IRANSans, Tahoma, Arial',
          width: '100%',
        },
        title: {
          text: 'سود های تخصیص یافته به اعضا',
          align: 'center',
          style: {
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#5a4a42',
          },
        },
        colors: ['#435EBE', '#21AE89', '#FDA700', '#fd397a', '#5CB0FF', '#694467', '#2A3F54', '#CCE5FF'],
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '30%',
            distributed: true,
            columnWidth: '100%',
          },
        },
        dataLabels: {
          enabled: true,
          formatter: (val) => val.toLocaleString('en-US'),
          offsetX: 80,
          position: 'end',
          style: {
            fontSize: '12px',
            colors: ['#333'],
            fontWeight: 'bold',
          },
        },
        xaxis: {
          categories: [],
          min: 0,
          max: 0,
          tickAmount: 5,
          forceNiceScale: false,
          labels: {
            formatter: (val) => {
              if (val >= 1000000000) {
                return (val / 1000000000).toFixed(1) + ' میلیارد ریال'
              } else if (val >= 1000000) {
                return (val / 1000000).toFixed(1) + ' میلیون ریال'
              } else if (val >= 1000) {
                return (val / 1000).toFixed(1) + ' هزار ریال'
              }
              return val.toLocaleString('en-US') + ' ریال'
            },
            style: {
              fontSize: '11px',
              colors: '#333',
            },
          },
        },
        yaxis: {
          labels: {
            offsetX: -120,
            align: 'right',
            maxWidth: 250,
            style: {
              fontSize: '12px',
              colors: '#333',
            },
          },
        },
        series: [
          {
            name: 'مقدار',
            data: [],
          },
        ],
        tooltip: {
          y: {
            formatter: (val) => val.toLocaleString('en-US') + ' ریال',
          },
        },
        legend: {
          show: false,
        },
      },
    };
  },
  methods: {
    roundUpToNiceNumber(value) {
      if (value === 0) return 100000000;
      const magnitude = Math.pow(10, Math.floor(Math.log10(value)));
      const normalized = value / magnitude;
      const niceNumbers = [1, 1.5, 2, 2.5, 3, 4, 4.5, 5, 6, 7, 8, 9, 10];
      const rounded = niceNumbers.find((num) => num >= normalized) || 10;
      return rounded * magnitude;
    },
    GetAllocatedProfitsData() {
      const formData = new FormData();
      formData.append('BnpCashazaId', this.$session.get('UserInfoNetPa').bnpCashDBtblAzaId);

      const DataAxiosRow = {
        ArryfildValue: formData,
        Method: 'Post',
        Action: 'AllCharts/SodTakhsis',
        Token: this.$session.get('TokenNetPa'),
      };

      this.$PostFormData(DataAxiosRow)
        .then((response) => {
          if (!response.success || !response.data || !Array.isArray(response.data)) return;

          const categories = response.data.map((item) => item.sharhsanad || 'بدون نام');
          const values = response.data.map((item) => item.sod || 0);

          const maxValue = Math.max(...values);
          const roundedMax = maxValue > 0 ? this.roundUpToNiceNumber(maxValue) : 200000000;

          this.chartOptions.xaxis.categories = categories;
          this.chartOptions.series[0].data = values;
          this.chartOptions.xaxis.min = 0;
          this.chartOptions.xaxis.max = roundedMax;
          this.chartOptions.xaxis.tickAmount = 5;
          this.chartKey++;
        })
        .catch((error) => {
          console.error('Error fetching allocated profits data:', error);
        });
    },
  },
  created() {
    this.GetAllocatedProfitsData();
  },
};
</script>

<style scoped>
.container-fluid {
  padding: 10px;
  background-color: #fff;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
}
</style>
